<template>
  <div class="layout--full-page">
    <div
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center main"
      id="page-login"
    >
      <div class="vx-col m-4">
        <div slot="no-body">
          <div class="body-wrapper">
            <div class="logo-container">
              <img
                src="@/assets/images/pages/slogan.webp"
                alt="slogan"
                class="slogan-image"
              />
              <img
                src="@/assets/images/pages/tm-3d.webp"
                alt="3dlogo"
                class="logo-image"
              />
            </div>

            <div class="login-tabs-container login-area">
              <img
                src="@/assets/images/pages/3d-slogan.webp"
                alt="3dlogo"
                class="logo-with-slogan-image"
              />
              <h4 class="mb-2 text-center">ورود به پنل کاربری</h4>
              <p class="text-center mb-2">
                {{
                  phone
                    ? "کد 4 رقمی را وارد کنید"
                    : "جهت ورود به پنل، شماره همراه خود را وارد کنید"
                }}
              </p>

              <user-code
                @edit-phone="phone = ''"
                :phone="phone"
                v-if="phone"
              ></user-code>
              <phone v-else @send-phone="setPhone($event)"></phone>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Phone from "./Phone.vue";
import Code from "./Code.vue";
import Cookies from "js-cookie";

export default {
  components: {
    Phone,
    UserCode: Code,
  },
  data() {
    return {
      phone: false,
    };
  },
  mounted() {
    const token = Cookies.get("employee_access_token");
    console.log(token);
  },
  methods: {
    setPhone(phone) {
      this.phone = phone;
    },
  },
};
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}

.body-wrapper {
  display: flex;
  width: 750px;
  background-color: #dce0eb;
  position: relative;
  overflow: hidden;
  display: flex;
  width: 750px;
  backdrop-filter: blur(10px);
  padding: 10px;
  border-radius: 10px;

  @media screen and (max-width: 750px) {
    width: 100%;
    background-color: unset !important;
  }
}

.logo-container {
  flex: 1.5;
  position: relative;
  display: flex;

  @media screen and (max-width: 750px) {
    display: none;
  }
}

.slogan-image {
  width: 250px;
  height: 82px;
  margin: 30px auto 0;
  object-fit: contain;
}

.logo-image {
  position: absolute;
  right: -165px;
  bottom: -60px;
  height: 430px;
}

.logo-with-slogan-image {
  display: none !important;

  @media screen and (max-width: 750px) {
    display: block !important;
    width: 270px;
    margin-bottom: 20px;
    transform: translateX(30px);
    object-fit: cover;
  }
}

.login-area {
  flex: 1;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  backdrop-filter: blur(10px);
  border-radius: 10px;
  margin: 6px;
  padding: 12px;
  background-color: white;
}
</style>
